<template>
  <v-row class="d-flex justify-center mt-0">
    <v-col cols="12">
      <v-expansion-panels v-model="panel">
        <v-expansion-panel readonly>
          <v-btn
            style="position: absolute; top: -15px; right: 55px; z-index: 1"
            color="success"
            small
            fab
            @click="abrir_recibo(null)"
          >
            <v-icon>fas fa-plus</v-icon>
          </v-btn>
          <v-expansion-panel-header class="py-0 px-4 text-h5" style="cursor: default">
            <div>
              <v-icon class="mb-1" left>fas fa-filter</v-icon>
              Filtro
            </div>
            <template v-slot:actions>
              <v-btn icon @click.stop="panel = panel === 1 ? 0 : 1">
                <v-icon>fas fa-chevron-down</v-icon>
              </v-btn>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pt-1">
            <v-form @submit.prevent="buscar">
              <v-row :no-gutters="$vuetify.breakpoint.xs">
                <v-col cols="6" md="2" class="py-1">
                  Empresa
                  <v-autocomplete
                    v-model="filtro.empresa"
                    item-text="nombre_corto"
                    item-value="id"
                    tabindex="1"
                    :items="empresas"
                    hide-details
                    autofocus
                    outlined
                    dense
                    @change="get_locales(); filtro.marca = null"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="6" md="2" class="py-1">
                  Marca
                  <v-autocomplete
                    v-model="filtro.marca"
                    item-text="nombre"
                    item-value="id"
                    tabindex="1"
                    :items="marcas_emp.filter(ma => ma.empresas.find(emp => emp == filtro.empresa))"
                    hide-details
                    outlined
                    dense
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="2" class="py-1">
                  Sucursal
                  <v-autocomplete
                    v-model="filtro.sucursal"
                    item-text="nombre"
                    item-value="id"
                    tabindex="1"
                    :items="sucursales"
                    hide-details
                    clearable
                    outlined
                    dense
                    @change="get_locales()"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="4" class="py-1">
                  Punto de venta
                  <v-autocomplete
                    v-model="filtro.ptovta"
                    item-text="nombre"
                    item-value="id"
                    tabindex="1"
                    :items="locales.filter(loc => loc.sucursal == filtro.sucursal && loc.empresa == filtro.empresa)"
                    hide-details
                    clearable
                    outlined
                    dense
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="2" class="py-1">
                  Estado
                  <v-autocomplete
                    v-model="filtro.estado"
                    item-text="nombre"
                    item-value="id"
                    tabindex="1"
                    :items="estados"
                    hide-details
                    clearable
                    outlined
                    dense
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" class="py-1">
                  Fecha
                  <FechaPickerRango
                    v-model="filtro.fecha"
                    :limpiar.sync="limpiar_fecha"
                  />
                </v-col>
                <BtnFiltro
                  :loading="load"
                  @clear="limpiar()"
                />
              </v-row>
            </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-data-table
        class="cebra elevation-2 mt-2"
        item-key="id"
        sort-by="id"
        :headers="headers"
        :items="recibos"
        :loading="load"
        sort-desc
        dense
      >
        <!-- este template se usa para aplicar formato a las columnas que tengan la propeidad formatter -->
        <template
          v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))"
          v-slot:[`item.${header.value}`]="{ value }"
        >
          {{ header.formatter(value) }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon
            color="wpp"
            title="Enviar WhatsApp"
            class="mr-2"
            small
            @click="enviar_wpp(item.telefono)"
          >
            fab fa-whatsapp
          </v-icon>
          <v-icon
            color="info"
            class="mr-2"
            title="Imprimir"
            small
            @click="imprimir(item)"
          >
            fas fa-print
          </v-icon>
          <v-icon
            color="info"
            title="Ver"
            class="mr-2"
            small
            @click="abrir_recibo(item.id)"
          >
            fas fa-eye
          </v-icon>
          <BtnConfirmar
            v-if="permiso && item.anular == 1"
            clase="mr-2"
            icono="fas fa-money-bill-wave"
            color="success"
            title="Rendir"
            :texto="`¿Desea <strong>rendir</strong> el recibo Nº <strong>${item.id}</strong>?`"
            :icon_button="true"
            :small="true"
            @action="rendir(item)"
          />
          <BtnConfirmar
            v-if="permiso && item.anular == 1"
            clase="mr-2"
            icono="fas fa-ban"
            color="error"
            title="Anular"
            :texto="`¿Desea <strong>anular</strong> el recibo Nº <strong>${item.id}</strong>?`"
            :icon_button="true"
            :small="true"
            @action="anular(item)"
          />
        </template>
        <template v-slot:no-data>
          <v-alert
            class="mx-auto mt-4"
            max-width="400"
            type="warning"
            border="left"
            dense
            text
          >
            No hay datos para los filtros seleccionados
          </v-alert>
        </template>
      </v-data-table>
    </v-col>

    <PDFViewer
      v-model="dialog_pdf"
      :pdf="pdf"
      :nombre="pdf_nombre"
      :titulo="pdf_titulo"
    />

  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import { format_money } from '../../util/utils'
import { reciboEfDycarA4 } from '../../util/plantillas/pdfs'
import BtnFiltro from '../../components/util/BtnFiltro'
import BtnConfirmar from '../../components/util/BtnConfirmar'
import FechaPickerRango from '../../components/util/FechaPickerRango'
import PDFViewer from '../../util/plantillas/PDFViewer'

export default {
  data () {
    return {
      panel: 0,
      load: false,
      limpiar_fecha: false,
      permiso: false,
      dialog_pdf: false,
      pdf: null,
      pdf_nombre: '',
      pdf_titulo: '',
      estados: [],
      recibos: [],
      headers: [
        { text: 'ID', value: 'id', align: 'end' },
        { text: 'Sol. Adhesión', value: 'sol_ad' },
        { text: 'Nombre', value: 'nombre' },
        { text: 'Nº Documento', value: 'num_doc', align: 'end' },
        { text: 'Importe', value: 'importe', align: 'end', formatter: format_money },
        { text: 'Usuario', value: 'usuario' },
        { text: 'Fecha', value: 'fecha' },
        { text: 'Estado', value: 'estado_nom' },
        { text: 'Marca', value: 'marca_nombre' },
        { text: 'Acciones', value: 'actions', sortable: false },
      ],
      filtro: {
        empresa: null,
        sucursal: null,
        ptovta: null,
        estado: null,
        fecha: [ null, null ],
        marca: null
      }
    }
  },
  created () {
    this.get_data()
  },
  computed: {
    ...mapState(['empresas', 'sucursales', 'locales']),
    ...mapState('dycar', ['marcas_emp'])
  },
  components: {
    BtnFiltro,
    BtnConfirmar,
    FechaPickerRango,
    PDFViewer,
  },
  methods: {
    enviar_wpp (telefono) {
      if (telefono) {
        window.open(`https://wa.me/549${telefono}`, '_blank')
      } else {
        this.$store.dispatch('show_snackbar', {
          text: 'No se encontró un numero de teléfono para el cliente',
          color: 'warning',
        })
      }
    },
    async imprimir (recibo) {
      this.$store.state.loading = true
      await this.$store.dispatch('dycar/get_recibo_data_print', recibo.id)
        .then(async (res) => {
          const numero = res.data.numero
          // genera el pdf para imprimir
          this.pdf = await reciboEfDycarA4(res.data)
          this.pdf_nombre = `recibo-efectivo-${numero}`
          this.pdf_titulo = `Recibo en efectivo Nº ${numero}`
          this.dialog_pdf = true
        })
        .catch(error => {
          this.$store.dispatch('show_snackbar', {
            text: error.message,
            color: 'error',
          })
        })
      this.$store.state.loading = false
    },
    async rendir (recibo) {
      this.$store.state.loading = true
      await this.$store.dispatch('dycar/anular_recibo', { id: recibo.id })
        .then(res => {
          // cambia el estado del item
          recibo.anular = 0
          recibo.estado_nom = this.estados.find(e => e.id == res.estado).nombre

          this.$store.dispatch('show_snackbar', {
            text: res.message,
            color: 'success',
          })
        })
        .catch(error => {
          this.$store.dispatch('show_snackbar', {
            text: error.message,
            color: 'error',
          })
        })
      this.$store.state.loading = false
    },
    async anular (recibo) {
      this.$store.state.loading = true
      await this.$store.dispatch('dycar/rendir_recibo', { id: recibo.id })
        .then(res => {
          // cambia el estado del item
          recibo.anular = 0
          recibo.estado_nom = this.estados.find(e => e.id == res.estado).nombre

          this.$store.dispatch('show_snackbar', {
            text: res.message,
            color: 'success',
          })
        })
        .catch(error => {
          this.$store.dispatch('show_snackbar', {
            text: error.message,
            color: 'error',
          })
        })
      this.$store.state.loading = false
    },
    async buscar () {
      if (!this.filtro.empresa) {
        return this.$store.dispatch('show_snackbar', {
          text: 'Debe ingresar una empresa',
          color: 'orange'
        })
      }
      this.recibos = []
      this.load = true
      await this.$store.dispatch('dycar/get_recibos', this.filtro)
        .then(res => {
          this.recibos = res.data
        })
        .catch(error => {
          this.$store.dispatch('show_snackbar', {
            text: error.message,
            color: 'error',
          })
        })
      this.load = false
    },
    async get_data () {
      this.$store.state.loading = true
      await this.$store.dispatch('dycar/get_marcas_emp')
      await this.$store.dispatch('dycar/get_estados')
        .then(res => {
          this.estados = res.data
        })
        .catch(error => {
          this.$store.dispatch('show_snackbar', {
            text: error.message,
            color: 'error',
          })
        })
      this.$store.state.loading = false

      // si solo tiene 1 empresa la selecciona por defecto
      if (this.empresas.length == 1) {
        this.filtro.empresa = this.empresas[0].id
      }
      // si solo tiene 1 sucursal la selecciona por defecto
      if (this.sucursales.length == 1) {
        this.filtro.sucursal = this.sucursales[0].id
      }

      // verifica si tiene permisos para anular
      await this.verificar_permiso()
    },
    async verificar_permiso () {
      this.$store.state.loading = true
      await this.$store.dispatch('dycar/verificar_permiso_anulacion')
        .then((res) => {
          if (res.permiso == 1) {
            this.permiso = true
          }
        })
        .catch(error => {
          this.$store.dispatch('show_snackbar', {
            text: error.message,
            color: 'error',
          })
        })
      this.$store.state.loading = false
    },
    get_locales () {
      let locales = this.locales.filter(loc => loc.sucursal == this.filtro.sucursal && loc.empresa == this.filtro.empresa)
      this.filtro.ptovta = locales.length == 1 ? locales[0].id : null
    },
    abrir_recibo (id) {
      let path = '/dycar/recibo-efectivo'
      if (id) {
        path = `${path}/${id}`
      }
      const routeData = this.$router.resolve({ path: path })
      window.open(routeData.href, '_blank')
    },
    limpiar () {
      this.filtro = {
        empresa: null,
        sucursal: null,
        ptovta: null,
        estado: null,
        fecha: [ null, null ],
        marca: null
      }
      this.limpiar_fecha = true
      
    }
  }
}
</script>